"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmDaterange = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_hook_breakpoints_1 = __importStar(require("react-hook-breakpoints"));
const Icon_1 = require("../Icon");
const Calendar_1 = require("../Calendar");
const InputText_1 = require("../InputText");
const breakpoints_1 = require("../utils/breakpoints");
const useDaterange_1 = require("./useDaterange");
const SmDaterange = (_a) => {
    var { componentsProps, value, className } = _a, props = __rest(_a, ["componentsProps", "value", "className"]);
    const { pickerValue, calendarValue, show, dropRef, setShow, onDaterangeChange, handleValueUpdate, } = (0, useDaterange_1.useDaterange)(value || {});
    const datepickerClassName = (0, classnames_1.default)('c-datepicker', {
        '-show': show,
    });
    const containerClassName = (0, classnames_1.default)('d-flex', className);
    return (react_1.default.createElement("div", { className: containerClassName, style: { gap: '1rem' }, ref: dropRef },
        react_1.default.createElement(InputText_1.SmInputText, Object.assign({ label: "", icon: react_1.default.createElement(Icon_1.SmIcon, { name: "date_range" }) }, componentsProps === null || componentsProps === void 0 ? void 0 : componentsProps.start, { onIconClick: (e) => {
                var _a, _b;
                setShow(!show);
                (_b = (_a = componentsProps === null || componentsProps === void 0 ? void 0 : componentsProps.start) === null || _a === void 0 ? void 0 : _a.onIconClick) === null || _b === void 0 ? void 0 : _b.call(_a, e);
            }, onFocus: (e) => {
                var _a, _b;
                setShow(true);
                (_b = (_a = componentsProps === null || componentsProps === void 0 ? void 0 : componentsProps.start) === null || _a === void 0 ? void 0 : _a.onFocus) === null || _b === void 0 ? void 0 : _b.call(_a, e);
            }, value: pickerValue.start || '', onChange: (e) => {
                var _a, _b;
                onDaterangeChange(e.target.value, 'start');
                (_b = (_a = componentsProps === null || componentsProps === void 0 ? void 0 : componentsProps.start) === null || _a === void 0 ? void 0 : _a.onChange) === null || _b === void 0 ? void 0 : _b.call(_a, calendarValue === null || calendarValue === void 0 ? void 0 : calendarValue.start, e);
            } }), show && (react_1.default.createElement(react_hook_breakpoints_1.default, { breakpoints: breakpoints_1.breakpoints },
            react_1.default.createElement(react_hook_breakpoints_1.MatchBreakpoint, { min: "md" },
                react_1.default.createElement("div", { className: datepickerClassName },
                    react_1.default.createElement(Calendar_1.SmCalendar, Object.assign({}, props, { value: calendarValue, multiCalendar: true, onSelectDate: (dateValue, event) => {
                            var _a, _b, _c, _d, _e;
                            if (dateValue) {
                                handleValueUpdate(dateValue);
                                (_b = (_a = componentsProps === null || componentsProps === void 0 ? void 0 : componentsProps.start) === null || _a === void 0 ? void 0 : _a.onChange) === null || _b === void 0 ? void 0 : _b.call(_a, calendarValue === null || calendarValue === void 0 ? void 0 : calendarValue.end);
                                (_d = (_c = componentsProps === null || componentsProps === void 0 ? void 0 : componentsProps.end) === null || _c === void 0 ? void 0 : _c.onChange) === null || _d === void 0 ? void 0 : _d.call(_c, calendarValue === null || calendarValue === void 0 ? void 0 : calendarValue.end);
                            }
                            (_e = props.onSelectDate) === null || _e === void 0 ? void 0 : _e.call(props, dateValue, event);
                        } }))))))),
        react_1.default.createElement(InputText_1.SmInputText, Object.assign({ label: "", icon: react_1.default.createElement(Icon_1.SmIcon, { name: "date_range" }) }, componentsProps === null || componentsProps === void 0 ? void 0 : componentsProps.end, { onFocus: (e) => {
                var _a, _b;
                setShow(true);
                (_b = (_a = componentsProps === null || componentsProps === void 0 ? void 0 : componentsProps.end) === null || _a === void 0 ? void 0 : _a.onFocus) === null || _b === void 0 ? void 0 : _b.call(_a, e);
            }, onIconClick: (e) => {
                var _a, _b;
                setShow(!show);
                (_b = (_a = componentsProps === null || componentsProps === void 0 ? void 0 : componentsProps.end) === null || _a === void 0 ? void 0 : _a.onIconClick) === null || _b === void 0 ? void 0 : _b.call(_a, e);
            }, value: pickerValue.end || '', onChange: (e) => {
                var _a, _b;
                onDaterangeChange(e.target.value, 'end');
                (_b = (_a = componentsProps === null || componentsProps === void 0 ? void 0 : componentsProps.end) === null || _a === void 0 ? void 0 : _a.onChange) === null || _b === void 0 ? void 0 : _b.call(_a, calendarValue === null || calendarValue === void 0 ? void 0 : calendarValue.end, e);
            } }))));
};
exports.SmDaterange = SmDaterange;
//# sourceMappingURL=index.js.map